import { getStatusCode } from './get-status-code';
/**
 * Returns a boolean value indicating if the provided error contains any of the
 * provided status codes.
 *
 * ### Usage :
 * ```
 *   hasStatusCode( myError,  [1234, 5678] )
 * ```
 *
 */
export function hasStatusCode(error, statusCodesList) {
    if (!Array.isArray(statusCodesList))
        statusCodesList = [statusCodesList];
    const statusCode = getStatusCode(error);
    return statusCode !== null && statusCodesList.includes(statusCode);
}
//# sourceMappingURL=has-status-code.js.map